const visileColumns = [
    {
      title: "Announcement ID",
      field: "ANNOUNCEMENT_ID",
      locked: false,
      filter: "text",
      width: "200",
      show: true,
    },
    // {
    //   title: "Position Number",
    //   field: "POSITION_NO",
    //   locked: false,
    //   filter: "text",
    //   width: "200",
    //   show: true,
    // },
    {
      title: "Date Posted",
      field: "DATE_POSTED",
      locked: false,
      filter: "date",
      format: "MM/DD/YYYY",
      editor: "date",
      width: "180",
      show: true,
    },
    {
      title: "Date Closed",
      field: "DATE_CLOSED",
      locked: false,
      filter: "date",
      format: "MM/DD/YYYY",
      editor: "date",
      width: "180",
      show: true,
      
    },
    {
      title: "Status",
      field: "status",
      locked: false,
      filter: "text",
      width: "180",
      show: true,
    },
    {
      title: "Requirements",
      field: "REQUIREMENTS",
      locked: false,
      filter: "text",
      width: "auto",
      show: true,
    },
    // {
    //   title: "Date Entered",
    //   field: "DATE_ENTERED",
    //   locked: false,
    //   filter: "date",
    //   format: "MM/DD/YYYY",
    //   editor: "date",
    //   width: "180",
    //   show: true,
    // },
    {
      title: "Announcement Type",
      field: "ANNOUNCEMENT_TYPE",
      locked: false,
      filter: "text",
      width: "200",
      show: true,
    },
  ];
  
  export default visileColumns;
  